import type { AxiosError } from 'axios'
import type { WizardVehicleAdditionalData as Step4FormValues } from 'BrokerTsLib/src/dtos'
import type { Offer } from 'BrokerTsLib/src/dtos/Offer'
import { useContext } from 'react'
import { useNavigate } from 'react-router'

import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Step4Form } from '../../../containers/carkulka/Step4Form'
import { WithOffer } from '../../../containers/hoc/WithOffer'
import { InsuranceInfo } from '../../../containers/InsuranceInfo/InsuranceInfo'
import { StepsContent } from '../../../context/StepsContext'
import { useGetOffer } from '../../../hooks/useOffer'
import { useSaveStep4, useUpdateLastWizardStep } from '../../../hooks/useWizard'
import { insuranceParamsContext } from '../../../layouts/Wizard'
import { Step4Context } from '../../carkulka/wizard/4'

const Step3Component = () => {
  const navigate = useNavigate()

  const { insuranceParams, insuranceParamsId, refetchInsuranceParams, isLoadingData } = useContext(insuranceParamsContext)
  const { mutateAsync: saveStep4Async } = useSaveStep4()
  const { mutateAsync: updateStep } = useUpdateLastWizardStep()

  if (!isLoadingData && insuranceParams && (insuranceParams.generalParams?.lastWizardStep ?? 1) < 3) {
    navigate('/carkulka/extra/wizard/too-far', { replace: true })
  }

  const offerId = insuranceParams?.generalParams.selectedOfferId

  const { isLoading, isFetching, data: axiosOffer, refetch } = useGetOffer(offerId ?? 0, { enabled: false, gcTime: 0, })
  const offer = axiosOffer?.data ?? {} as Offer

  const handleSubmit = (values: Step4FormValues) => {
    return new Promise((resolve, reject) =>
      saveStep4Async(values)
        .then((response) => {
          if (values.nextPage == 'next') {
            if ((insuranceParams?.generalParams.lastWizardStep ?? 3) < 4) {
              updateStep({ paramsId: Number(insuranceParamsId), step: 4, stepsStep: 'carkulka-extra' }).
                then(() => {
                  refetchInsuranceParams().then(() => {
                    navigate(`/carkulka/extra/wizard/4/${insuranceParamsId}`)
                  })
                })
            }
            else {
              refetchInsuranceParams().then(() => {
                navigate(`/carkulka/extra/wizard/4/${insuranceParamsId}`)
              })
            }
          } else {
            window.scrollTo(0, 0)
          }

          resolve(response)
        })
        .catch((err: AxiosError) => {
          if (!(err.response && err.response.status === 400 && err.response.data))
            return

          reject(err)
        })
        .finally(() => { }))
  }

  return (
    <Step4Context.Provider value={{ offer: offer! }}>
      <Section>
        <Container>
          <StepsContent step={3}>
            <Steps icon="car" />

            <InsuranceInfo />

            <Step4Form onSubmit={handleSubmit} />
          </StepsContent>
        </Container>

        <WizardForbiddenMessage />
      </Section>
    </Step4Context.Provider>
  )
}

export const Step3 = WithOffer(Step3Component)